import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { updateSentryForMFE } from '../utils/sentry';
import { detectLocale } from '../utils/localeUtils';

export interface UseModFedResult {
  /** True while the dynamic import and remote `default()` mount are in progress. */
  isRemoteLoading: boolean;
}

export const useModFed = (
  rootID: string,
  importRemote,
): UseModFedResult => {
  const history = useHistory();
  const localeCountryCode = detectLocale();
  console.log('🌍 shell app: Locale country code detected:', localeCountryCode);
  const [isRemoteLoading, setIsRemoteLoading] = useState(
    () => importRemote != null,
  );
  
  const [config] = useState({
    defaultHistory: history,
    onNavigate: ({ pathname: nextPath }) => {
      const { pathname } = history.location;
      if (pathname !== nextPath) {
        history.push(nextPath);
      }
    },
    updateSentryForMFE,
    localeCountryCode,
  });

  useEffect(() => {
    let unmountFunc: (() => void) | undefined;
    if (!importRemote) {
      return;
    }
    const mountAMS = async () => {
      try {
        const module = await importRemote();
        const { onParentNavigate, unmount } = module.default(
          document.getElementById(rootID),
          config,
        );
        unmountFunc = unmount;
        if (config.defaultHistory && onParentNavigate) {
          config.defaultHistory.listen(onParentNavigate);
        }
      } catch (error) {
        console.log('Failed to mount remote module:', error);
      } finally {
        setIsRemoteLoading(false);
      }
    };
    mountAMS();

    return () => {
      if (unmountFunc) {
        unmountFunc();
      }
    };
  }, []);

  return { isRemoteLoading };
};